import { isoCurrency } from "./utils";
class ElementEvent {
}
export let events = [];
export let shogin_elements = [];
export let add_elements = [];
let clicked_elements = [];
class GACLKECEvent {
    constructor(className, eventList) {
        this.className = className;
        this.eventList = eventList;
        this.eventList = eventList;
        this.className = className;
    }
    process(el, eventName, inputName) {
        console.log('CLKEC_EVENTS', `process event ${eventName}`);
        let inputEl;
        inputEl = el.querySelector(`input[name=${inputName}]`);
        if (!inputEl) {
            console.log('CLKEC_EVENTS', 'warning', el, `no input data input[name=${inputName}]`);
            return;
        }
        let data = inputEl.value;
        if (!data) {
            console.log('CLKEC_EVENTS', 'warning', el, 'empty data');
            return;
        }
        let detail = Object({
            'el': el,
            'data': data
        });
        try {
            document.dispatchEvent(new CustomEvent(eventName, {
                'detail': detail
            }));
        }
        catch (e) {
            console.log('CLKEC_EVENTS', eventName, el, data, e);
        }
    }
    execute(el, eventName) {
        console.log('CLKEC_EVENTS', `execute event ${eventName}`);
        console.log('DISABLEGA', window.disableGA);
        if (window.disableGA) {
            return;
        }
        if (!el) {
            console.log('CLKEC_EVENTS', eventName, el, `invalid element`);
            return;
        }
        let exeElement;
        exeElement = el.closest(`.${this.className}`);
        if (!exeElement) {
            console.log('CLKEC_EVENTS', eventName, el, `not contains class ${this.className}`);
            return;
        }
        let item = exeElement;
        this.eventList.forEach((data) => {
            if (eventName == data[0]) {
                console.log('CLKEC_EVENTS', `process event ${eventName}`, data);
                this.process(item, data[1], data[2]);
            }
        });
    }
}
let gaProductItem = new GACLKECEvent('gaclkec-product-item', [
    ['clicked', 'CLKEC_GA_EVENT', 'raw-event-fbclicked'],
    ['clicked', 'CLKEC_GA_EVENT', 'raw-event-clicked'],
    ['showing', 'CLKEC_GA_EVENT', 'raw-event-showing'],
    ['showing', 'CLKEC_PRODUCT_SHOWING', 'raw-data'],
]);
let gaPromoItem = new GACLKECEvent('gaclkec-promo-item', [
    ['clicked', 'CLKEC_GA_EVENT', 'raw-event-clicked'],
    ['showing', 'CLKEC_GA_EVENT', 'raw-event-showing'],
    ['showing', 'CLKEC_PRODUCT_SHOWING', 'raw-data'],
]);
let gaBanner = new GACLKECEvent('gaclkec-banner', [
    ['clicked', 'CLKEC_GA_EVENT', 'raw-event-clicked'],
    ['showing', 'CLKEC_GA_EVENT', 'raw-event-showing'],
    ['showing', 'CLKEC_BANNER_SHOWING', 'raw-data'],
]);
let gaProductItemList = new GACLKECEvent('gaclkec-view-item-list', [
    ['clicked', 'CLKEC_GA_EVENT', 'raw-event-fbclicked'],
    ['showing', 'CLKEC_GA_EVENT', 'raw-event-showing'],
]);
let gaSelectProductItemList = new GACLKECEvent('gaclkec-select-item-list', [
    ['clicked', 'CLKEC_GA_EVENT', 'raw-event-fbclicked'],
    ['clicked', 'CLKEC_GA_EVENT', 'raw-event-clicked'],
]);
let gaProductItemView = new GACLKECEvent('gaclkec-view-item', [
    ['showing', 'CLKEC_GA_EVENT', 'raw-event-showing'],
    ['showing', 'CLKEC_GA_EVENT', 'raw-event-fbshowing'],
]);
// let fbProductItem = new GACLKECEvent('fbclkec-view_item', [
//     ['showing', 'CLKEC_GA_EVENT', 'raw-event-fbshowing'],
//     ['showing', 'CLKEC_PRODUCT_SHOWING', 'raw-data'],
// ]);
const dom_events = [
    gaProductItem,
    gaProductItemList,
    gaSelectProductItemList,
    gaProductItemView,
    gaPromoItem,
    gaBanner,
    // fbProductItem,
];
function on_showing_element(el) {
    if (shogin_elements.indexOf(el) >= 0) {
        return;
    }
    shogin_elements.push(el);
    console.log('CLKEC_EVENTS', 'on_showing_element', el);
    dom_events.forEach(obj => {
        obj.execute(el, 'showing');
    });
}
function on_click_element(event) {
    let el = event.target;
    if (clicked_elements.indexOf(el) >= 0) {
        return;
    }
    clicked_elements.push(el);
    console.log('CLKEC_EVENTS', 'on_click_element', event);
    dom_events.forEach(obj => {
        obj.execute(el, 'clicked');
    });
    setTimeout(function () {
        clicked_elements = clicked_elements.filter(function (value, index, arr) {
            return value != el;
        });
    }, 1000);
}
function on_showing_elements(changes) {
    changes.forEach((entry) => {
        if (entry.isIntersecting) {
            if (entry.intersectionRatio >= 0.75) {
                on_showing_element(entry.target);
            }
        }
    });
}
let observer = new IntersectionObserver(on_showing_elements, { rootMargin: '0px', threshold: 1.0 });
dom_events.forEach(obj => {
    document.querySelectorAll(`.${obj.className}`).forEach(el => {
        observer.observe(el);
        el.addEventListener('click', event => {
            console.log('DISABLEGA', window.disableGA);
            if (window.disableGA) {
                return;
            }
            //event.stopPropagation();
            //event.preventDefault();
            on_click_element(event);
        });
    });
});
let ntyrty = new MutationObserver(mutationRecords => {
    //console.log('MutationObserver', mutationRecords.length)
    console.log('DISABLEGA', window.disableGA);
    if (window.disableGA) {
        return;
    }
    mutationRecords.forEach(rel => {
        dom_events.forEach(obj => {
            if (rel.type == 'childList') {
                let parent = rel.target;
                // console.log('CLKEC_EVENTS', obj.className, parent.querySelectorAll(`.${obj.className}`).length)
                parent.querySelectorAll(`.${obj.className}`).forEach(el => {
                    if (!el.classList.contains('clkec-obs')) {
                        observer.observe(el);
                        el.classList.add('clkec-obs');
                        el.addEventListener('click', event => {
                            console.log('DISABLEGA', window.disableGA);
                            if (window.disableGA) {
                                return;
                            }
                            // event.stopPropagation();
                            // event.preventDefault();
                            on_click_element(event);
                        });
                    }
                });
            }
        });
    });
});
// observe everything except attributes
ntyrty.observe(document.body, {
    childList: true,
    subtree: true,
    characterDataOldValue: false // pass old data to callback
});
let gaAddToCart = new GACLKECEvent('gaclkec-atc', [
    ['atc', 'CLKEC_GA_EVENT', 'raw-event-atc'],
    ['atc', 'CLKEC_GA_EVENT', 'raw-event-fbatc'],
]);
document.addEventListener('AddProductEvent', function (value) {
    var _a;
    var evt = (_a = value === null || value === void 0 ? void 0 : value.detail) === null || _a === void 0 ? void 0 : _a.event;
    if (!evt || !evt.target || !evt.target.parentNode)
        return;
    var el = evt.target.parentNode;
    if (!el || typeof el.closest !== 'function')
        return;
    var exeElement = el.closest('.gaclkec-atc');
    if (!exeElement)
        return;
    if (add_elements.indexOf(exeElement) >= 0)
        return;
    add_elements.push(exeElement);
    console.log('CLKEC_EVENTS', 'on_add_to_cart', exeElement);
    gaAddToCart.execute(exeElement, 'atc');
});
document.addEventListener('AddPromoEvent', function (value) {
    var _a;
    console.log('AddPromoEvent', value);
    var products = ((_a = value === null || value === void 0 ? void 0 : value.detail) === null || _a === void 0 ? void 0 : _a.products) || [];
    products.forEach((product) => {
        if (!product || !product.id)
            return;
        var el = document.getElementById('id_product_' + product.id);
        if (!el || typeof el.closest !== 'function')
            return;
        var exeElement = el.closest('.gaclkec-atc');
        if (!exeElement)
            return;
        if (add_elements.indexOf(exeElement) >= 0)
            return;
        add_elements.push(exeElement);
        console.log('CLKEC_EVENTS', 'on_add_to_cart', exeElement);
        gaAddToCart.execute(exeElement, 'atc');
    });
});
document.addEventListener('CheckoutUpdated', function (e) {
    var currency = isoCurrency(window.Clkec.cart.currency);
    try {
        if (window.fbq) {
            // AddPaymentInfo content_category, content_ids, contents, currency, value
            var num_items = 0;
            var contents = (window.Clkec.cart.get_products() || []).map((item) => {
                num_items += item.quantity;
                return {
                    'id': item.id || item.code,
                    'product_id': item.code || item.id,
                    'quantity': item.quantity,
                    'item_price': item.price
                };
            });
            var paymentData = {
                content_ids: contents.map((item) => item.product_id || item.id),
                contents: contents,
                num_items: num_items,
                currency: currency,
                value: window.Clkec.cart.total
            };
            window.fbq("track", "AddPaymentInfo", paymentData);
            console.log('CLKEC_EVENTS_EVENT', `window.fbq("track", "AddPaymentInfo", ${JSON.stringify(paymentData)});`);
        }
    }
    catch (e) {
        console.error(e);
    }
    try {
        if (window.gtag) {
            var num_items = 0;
            var items = window.Clkec.cart.get_products().map((item) => {
                num_items += item.quantity;
                return {
                    item_id: item.id,
                    item_name: item.name,
                    item_brand: item.brand.name,
                    price: item.price,
                    currency: currency,
                    quantity: item.quantity
                };
            });
            var addPInfo = {
                currency: currency,
                coupon: window.Clkec.cart.promocodes.map((el) => { return el['code']; }).join(','),
                items: items,
                value: window.Clkec.cart.total
            };
            window.gtag('event', 'add_payment_info', addPInfo);
            console.log('CLKEC_EVENTS_EVENT', `window.gtag('event', 'add_payment_info', ${JSON.stringify(addPInfo)});`);
        }
    }
    catch (e) {
        console.error(e);
    }
}, false);
